import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import { Facebook, Twitter, Instagram } from "@material-ui/icons";
import theme from "../../../theme-admin";

const useStyles = makeStyles((th) => ({
  socialIcons: {
    display: "flex",
    gap: th.spacing(2),
    alignSelf: "center",
    justifyContent: "flex-end",
    [th.breakpoints.down("xs")]: {
      marginTop: th.spacing(1),
    },
  },
  socialIcon: {
    width: 32,
    height: 32,
    color: th.palette.white,
    backgroundColor: th.palette.tertiaryColor || th.palette.primary.main,
    borderRadius: "50%",
    padding: th.spacing(1 / 2),
  },
}));

export const SocialContact = ({ instagram, facebook, twitter }) => {
  const classes = useStyles(theme);

  return (
    <Box className={classes.socialIcons}>
      {instagram && (
        <a href={instagram} target="_blank" rel="noopener noreferrer">
          <Instagram className={classes.socialIcon} />
        </a>
      )}
      {facebook && (
        <a href={facebook} target="_blank" rel="noopener noreferrer">
          <Facebook className={classes.socialIcon} />
        </a>
      )}
      {twitter && (
        <a href={twitter} target="_blank" rel="noopener noreferrer">
          <Twitter className={classes.socialIcon} />
        </a>
      )}
    </Box>
  );
};
